import React from "react";
import { Button } from "@mui/material";

const SaveAs: React.FC = () => {
  const handleSaveAs = () => {
    const mapData = localStorage.getItem("map-active");

    if (!mapData) {
      alert("No active map found to save.");
      return;
    }

    // Generate timestamped filename
    const now = new Date();
    const timestamp = now
      .toISOString()
      .replace(/T/, "_") // Replace "T" with "_"
      .replace(/:/g, "-") // Replace ":" with "-"
      .split(".")[0]; // Remove milliseconds

    const fileName = `map-${timestamp}.json`;

    // Create a Blob for downloading
    const blob = new Blob([mapData], { type: "application/json" });
    const url = URL.createObjectURL(blob);

    // Create a download link
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Clean up URL object
    URL.revokeObjectURL(url);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleSaveAs}
      sx={{ mt: 1 }}
    >
      Save As
    </Button>
  );
};

export default SaveAs;